import { useState } from 'react'
import { useT } from '../i18n'

/**
 * Three Step TV landing — no auth, no hosting. The TV is a display;
 * whoever wants to host does it from the main app on their phone.
 * Landing just asks for a code and redirects to the room view.
 */
export function ThreeStepTvHomeScreen() {
  const t = useT()
  const [code, setCode] = useState('')
  const trimmed = code.trim().toUpperCase()
  const canSubmit = trimmed.length === 6

  function submit(e: React.FormEvent) {
    e.preventDefault()
    if (!canSubmit) return
    window.location.href = `/tv/three-step/${trimmed}`
  }

  const host = 'games.jordandraper.com'

  return (
    <div className="min-h-screen flex flex-col bg-brand-bg text-brand-text">
      <div className="flex-1 flex flex-col items-center justify-center px-12 py-16 text-center">
        <p className="text-sm font-semibold uppercase tracking-[0.3em] text-brand-muted mb-4">
          Jordan Draper Games
        </p>
        <h1 className="font-display text-[6rem] leading-none font-black text-brand-text">
          THREE STEP SOLUTION
        </h1>
        <p className="font-display text-2xl text-brand-muted mt-6 max-w-2xl">
          Open the app on your phone at{' '}
          <span className="font-mono font-semibold text-brand-text">{host}</span>{' '}
          and tap <span className="font-semibold text-brand-text">{t('Project to TV')}</span>{' '}
          to get a code. Then enter it here.
        </p>

        <form onSubmit={submit} className="mt-12 w-full max-w-xl">
          <label className="block text-left mb-3">
            <span className="text-sm font-semibold uppercase tracking-wide text-brand-muted">{t('Room code')}</span>
          </label>
          <input
            type="text"
            value={code}
            onChange={e => setCode(e.target.value.replace(/[^A-Za-z0-9]/g, '').slice(0, 6))}
            placeholder="ABCDEF"
            autoFocus
            autoCapitalize="characters"
            inputMode="text"
            className="w-full px-6 py-6 rounded-3xl border-4 border-brand-border
                       bg-white text-brand-text font-display font-black
                       text-6xl tracking-[0.35em] text-center uppercase
                       focus:outline-hidden focus:border-game-three-step-dark
                       focus:ring-4 focus:ring-game-three-step-dark/20"
          />
          <button
            type="submit"
            disabled={!canSubmit}
            className="mt-6 w-full px-16 py-6 rounded-3xl bg-game-three-step-dark text-white
                       font-display text-3xl font-bold shadow-float
                       active:scale-95 transition-transform disabled:opacity-40
                       disabled:cursor-not-allowed"
          >{t('Open room →')}</button>
        </form>
      </div>

      <footer className="px-8 pb-6 text-xs text-brand-muted text-center">
        Jordan Draper Games
      </footer>
    </div>
  )
}
